import React, { useEffect } from "react";

const FacebookShareButton = () => {
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FB_APP_ID,
        status: true,
        cookie: true,
        version: "v2.6",
      });
    };

    if (!window.document.getElementById("facebook-jssdk")) {

    const js = window.document.createElement("script");

    js.id = "facebook-jssdk";
    js.async = true;
    js.defer = true;
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.6";

    window.document.body.appendChild(js);
    }
  }, []);

  const handleClick = () => {
    window.FB.ui(
      {
        display: "popup",
        method: "share",
        href: window.location.href,
      },
      function (response) {}
    );
  };

  return (
    <span
      style={{
        width: "auto",
        height: 25,
        background: "#3b5998",
        fontSize: "14px",
        lineHeight: "14px",
        cursor: "pointer"
      }}
      className="ml-2 text-white p-2 font-weight-bold rounded"
      onClick={handleClick}
    >
      Facebook
    </span>
  );
};

export default FacebookShareButton;
